import { useQuery } from '@apollo/client';
import { QUERY_DOG_TRAINERS_PAGE } from '../../graphql/dog-queries';

export default function useGetDogTrainersPage(slug) {
    const { data, loading } = useQuery(QUERY_DOG_TRAINERS_PAGE, {
        variables: { slug },
    });
    return { data: data?.dogTrainerPage, loading };
}
